export default {
  data() {
    return {
      list: []
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    // 解密
    async getList() {
      const key = this.$route.query.key;
      console.log(encodeURIComponent(key));
      const [err, res] = await this.$http.post("/golang/app_personal_info/link/decrypt", {
        key: encodeURIComponent(key)
      });
      if (err) return;
      this.list = res.list;
    },

    // 链接跳转
    goUrl(url) {
      window.location.href = url;
    }

  }
};